export const clipText = (value: string | null | undefined, max: number) => {
  const text = String(value ?? '')
    .replace(/\s+/g, ' ')
    .trim()

  return text.length > max ? `${text.slice(0, max - 1)}…` : text
}
